export default __webpack_public_path__ + "static/wood-style-2-7723af6206c4fed535486194a92ff72e.png";